import { useMemo } from 'react';
import ChatUrgentIcon from '@shared/assets/icons/chat/urgent.svg';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { Colors } from '@shared/styles';
import { notNil } from '@shared/util/notNil';
import { MBStackedUsers } from '../stackedUsers';
import { Styles } from '../styles';
import { MBBaseSystemMessage } from './base';
import { toString } from './toString';
import { MBSystemMessageProps } from './index';

export function UserJoined({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      image={<MBUserImage size="tiny" user={message.sender} style={Styles.systemMessageIcon} />}
      text={toString(message)}
      date={message.createdAt}
    />
  );
}

export function UsersAdded({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      image={<MBUserImage size="tiny" user={message.sender} style={Styles.systemMessageIcon} />}
      text={toString(message)}
      date={message.createdAt}
    />
  );
}

export function UsersRemoved({ message, ...otherProps }: MBSystemMessageProps) {
  const users = useMemo(() => message.meta?.users?.filter(notNil) ?? [], [message.meta?.users]);
  return (
    <MBBaseSystemMessage
      {...otherProps}
      image={
        <View>
          <MBStackedUsers users={users} />
        </View>
      }
      text={toString(message)}
      date={message.createdAt}
    />
  );
}

export function MeRemoved({ message, ...otherProps }: MBSystemMessageProps) {
  return <MBBaseSystemMessage {...otherProps} text={toString(message)} date={message.createdAt} />;
}

export function UserNotified({ message, ...otherProps }: MBSystemMessageProps) {
  return (
    <MBBaseSystemMessage
      {...otherProps}
      icon={ChatUrgentIcon}
      color={Colors.v2.green}
      text={toString(message)}
      date={message.createdAt}
    />
  );
}
